import React, {useState} from 'react';
import ls from './PropertiesEditor.less';
import {Icon} from "antd";
import {Map} from "immutable";

const EMPTY_MAP = Map();

export function PropertiesEditor({props, schema, onChange}) {

  if (!props) {
    return <span>🏊</span>
  }

  if (!schema) {
    return <span>{JSON.stringify(props.toJSON())}</span>
  }

  return <table className={ls.root}>
    <tbody>

      <PropertiesEditorChunk props={props} schema={schema} onChange={onChange} level={1} prefix={[]} />

    </tbody>
  </table>;

}

export function PropertiesEditorChunk({props, schema, onChange, prefix, level}) {

  return Object.keys(schema.properties).sort().map(propName => {

    const propDef = schema.properties[propName];

    if (propDef.type === 'array') {
      console.error("PropertiesEditor: arrays not supported");
      return;
    }

    function changeHandler(e) {
      const path = [...prefix, propName];
      const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
      onChange(path, value);
    }

    const paddingLeft = (level * 5)+'px';
    let control;
    const value = props.get(propName);
    const strValue = value || '';
    if (propDef.type === 'string' && propDef.enum) {
      control = <select value={strValue} onChange={changeHandler}>
        <option value={''}>{'<empty>'}</option>
        {propDef.enum.map(enumVal => <option key={enumVal} value={enumVal}>{enumVal}</option>)}
      </select>;
    } else if (propDef.type === 'boolean') {
      control = <input checked={!!value} onChange={changeHandler} type="checkbox"/>;

    } else if (propDef.type === 'object') {
      return <SubProperties key={propName} level={level} propName={propName} props={value || EMPTY_MAP} schema={propDef} prefix={prefix} onChange={onChange}/>
    } else {
      control = <input value={strValue} onChange={changeHandler}/>;
    }

    return <tr key={propName}>

      <td style={{paddingLeft}} className={ls.name}>{propName}</td>

      <td className={ls.value}>{control}</td>

    </tr>;

  });

}

function SubProperties({level, propName, props, schema, prefix, onChange}) {
  const [collapsed, setCollapsed] = useState(!!schema['x-editor-collapsed']);
  const paddingLeft = (level * 5)+'px';
  return <React.Fragment>
    <tr key={propName}>
      <td style={{paddingLeft}} className={ls.caption} colSpan={2}>
        <span className={ls.collapseBtn} onClick={() => setCollapsed(!collapsed)}>
          <Icon type={collapsed ? 'caret-right' : 'caret-down'} />
          {propName}
        </span>
      </td>
    </tr>
    {!collapsed && <PropertiesEditorChunk props={props} schema={schema} level={level + 1} prefix={[...prefix, propName]} onChange={onChange}/>}
  </React.Fragment>

}